import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { ThemeProvider } from "./context/ThemeContext";
import { HelmetProvider } from "react-helmet-async";
import ScrollToTop from "./components/shared/ScrollToTop";

// Layout
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";

// Pages
import HomePage from "./pages/HomePage";
import LeLabPage from "./pages/LeLabPage";
import ChaussuresPage from "./pages/ChaussuresPage";
import TextilePage from "./pages/TextilePage";
import AccessoiresPage from "./pages/AccessoiresPage";
import NutritionPage from "./pages/NutritionPage";
import EquipePage from "./pages/EquipePage";
import EvenementsPage from "./pages/EvenementsPage";
import EntrainementsPage from "./pages/EntrainementsPage";
import RendezVousPage from "./pages/RendezVousPage";
import MentionsLegalesPage from "./pages/MentionsLegalesPage";
import ConfidentialitePage from "./pages/ConfidentialitePage";
import NotFoundPage from "./pages/NotFoundPage";
import AdminPage from "./pages/AdminPage";

// Layout wrapper
const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 pt-[104px]">
        {children}
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <div className="App">
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              {/* Admin route - sans Layout */}
              <Route path="/panel-x7k9m2" element={<AdminPage />} />
              
              {/* Routes publiques avec Layout */}
              <Route path="/" element={<Layout><HomePage /></Layout>} />
              <Route path="/le-lab" element={<Layout><LeLabPage /></Layout>} />
              <Route path="/chaussures" element={<Layout><ChaussuresPage /></Layout>} />
              <Route path="/textile" element={<Layout><TextilePage /></Layout>} />
              <Route path="/accessoires" element={<Layout><AccessoiresPage /></Layout>} />
              <Route path="/nutrition" element={<Layout><NutritionPage /></Layout>} />
              <Route path="/equipe" element={<Layout><EquipePage /></Layout>} />
              <Route path="/foulees-vertes-co" element={<Layout><EvenementsPage /></Layout>} />
              <Route path="/entrainements" element={<Layout><EntrainementsPage /></Layout>} />
              <Route path="/rendez-vous" element={<Layout><RendezVousPage /></Layout>} />
              <Route path="/mentions-legales" element={<Layout><MentionsLegalesPage /></Layout>} />
              <Route path="/confidentialite" element={<Layout><ConfidentialitePage /></Layout>} />
              <Route path="*" element={<Layout><NotFoundPage /></Layout>} />
            </Routes>
            <Toaster position="top-right" />
          </BrowserRouter>
        </div>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
